import { Component, OnInit, ViewChild } from '@angular/core';
import {
  CardToken,
  TransactionType,
  MemberCard,
  ProviderName,
} from '@fgb/core';
import { Observable } from 'rxjs';
import { CardTokenListComponent } from 'src/app/modules/ecash/components/card-token-list/card-token-list.component';
import { jetCashNavItems } from 'src/app/shared/utilities/navigation-pills-settings';
import { Regex } from 'src/app/shared/utilities/regex';

@Component({
  selector: 'fgb-ecash-page',
  templateUrl: './ecash-page.component.html',
  styleUrls: ['./ecash-page.component.scss'],
})
export class EcashPageComponent implements OnInit {
  defaultCardToken$: Observable<CardToken>;
  memberCard$: Observable<MemberCard | undefined>;
  combinedCard$: Observable<number | undefined>;
  @ViewChild('mobileCardTokenList', { static: false }) mobileCardTokenList: CardTokenListComponent;

  regex = Regex;
  provider = ProviderName.Sage;
  jetCashNavItems = jetCashNavItems;
  transactionStartDate: Date;
  transactionEndDate: Date;
  transactionType: TransactionType;
  transactionTypes = TransactionType;
  memberId: string;
  ngOnInit() {
  }

  setTransactionType(type: TransactionType) {
    this.transactionType = type;
  }

  openAddNewCard() {
    this.mobileCardTokenList.openAddNewCard();
  }
}
